import React from 'react';
import styled from 'styled-components';
import { AnimatedText } from './animated-text';
import { BouncingBox } from './bouncing-box-loader';

const Wrapper = styled.div`
  height: 100%;
  margin-right: ${(props) => props.marginRight};
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
`;

function BouncingBoxWithText(props) {
  const { loadingText, marginRight = 'unset' } = props;
  return (
    <Wrapper marginRight={marginRight}>
      <BouncingBox />
      <AnimatedText loadingText={loadingText} />
    </Wrapper>
  );
}

export { BouncingBoxWithText };
